import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-list",
  "use": "icon-list-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-list\"><defs><style type=\"text/css\"></style></defs><path d=\"M822.4 835.2h-620.8c-12.8 0-25.6-12.8-25.6-25.6s12.8-25.6 25.6-25.6h620.8c12.8 0 25.6 12.8 25.6 25.6s-12.8 25.6-25.6 25.6z m0-294.4h-620.8c-12.8 0-25.6-12.8-25.6-25.6s12.8-25.6 25.6-25.6h620.8c12.8 0 25.6 12.8 25.6 25.6s-12.8 25.6-25.6 25.6z m-537.6-300.8h-83.2c-12.8 0-25.6-12.8-25.6-25.6s12.8-25.6 25.6-25.6h83.2c19.2 0 25.6 12.8 25.6 25.6s-6.4 25.6-25.6 25.6z m537.6 0h-441.6c-12.8 0-25.6-12.8-25.6-25.6s12.8-25.6 25.6-25.6h435.2c12.8 0 25.6 12.8 25.6 25.6s-6.4 25.6-19.2 25.6z\" fill=\"#f4ea2a\" p-id=\"4252\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/list.svg
// module id = vuHp
// module chunks = 132